// @ts-nocheck
import { useMemo } from 'react';
import { CancelWithReasonDialog } from '../components/cancel-with-reason-dialog';

type PaymentCancelFormVariant = 'taxInvoice' | 'noPayment';

interface PaymentCancelFormDialogProps {
    variant: PaymentCancelFormVariant;
    isLoading?: boolean;
    onClose: () => void;
    onConfirm: (reason: string) => void;
}

/**
 * 결제 취소 폼 다이얼로그 (세금계산서 또는 결제 없음)
 * CancelWithReasonDialog를 사용하여 구현
 */
export function PaymentCancelFormDialog({ variant, isLoading = false, onClose, onConfirm }: PaymentCancelFormDialogProps) {
    const copy = useMemo(() => {
        if (variant === 'taxInvoice') {
            return {
                title: '세금계산서로 결제한 요금제를 취소할까요?',
                description: '요금제 취소 사유를 입력하고 취소를 진행하면 즉시 요금제가 해지됩니다.\n세금계산서 취소 및 환불을 먼저 완료한 뒤 요금제 취소를 진행해 주세요.',
                reasonPlaceholder: '요금제 취소 사유를 입력해주세요',
                warningText: '※ 취소 후에는 복구할 수 없습니다.',
                confirmButtonText: '요금제 취소하기',
            };
        }

        return {
            title: '결제 없이 적용한 요금제를 취소할까요?',
            description: '요금제 취소 사유를 입력하면 즉시 요금제가 해지됩니다.\n취소 시 채널 이용이 중단되므로, 서비스 영향도를 확인한 뒤 진행해 주세요.',
            reasonPlaceholder: '요금제 취소 사유를 입력해주세요',
            warningText: '※ 취소 후에는 복구할 수 없습니다.',
            confirmButtonText: '요금제 취소하기',
        };
    }, [variant]);

    return (
        <CancelWithReasonDialog
            title={copy.title}
            description={copy.description}
            reasonPlaceholder={copy.reasonPlaceholder}
            confirmButtonText={copy.confirmButtonText}
            warningText={copy.warningText}
            isLoading={isLoading}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
}